import * as angular from "angular";

export class ApiUserService {
    private apiRoot: string;
    private v2Root: string;
    private $http: any;

    constructor($http: any, __env: any) {
        this.$http = $http;
        this.apiRoot = __env.apiUrl() + "/user";
        this.v2Root = "/v2/user";
    }

    remove(data: any): Promise<object> {
        return this.$http.delete(this.apiRoot + "/" + data.id, data);
    }

    all(data: any, timeout?: any): Promise<object> {
        return this.$http.get(this.apiRoot + "/all", {
            params: data,
            timeout: timeout,
        });
    }

    info(data: any): Promise<object> {
        return this.$http.get(this.v2Root + "/" + data.id, data);
    }

    country(data?: any): Promise<object> {
        return this.$http.get(this.apiRoot + "/country", data);
    }

    updateCard(data: any): Promise<object> {
        return this.$http.post(this.apiRoot + "/card", data);
    }

    resetPassword(data: any): Promise<object> {
        return this.$http.post(this.apiRoot + "/reset_password", data);
    }

    update(data: any): Promise<object> {
        return this.$http.post(this.v2Root + "/update/" + data.uid, data);
    }

    register(data: any): Promise<object> {
        return this.$http.post(this.apiRoot + "/register", data);
    }

    sandboxRegister(data: any): Promise<object> {
        return this.$http.post(this.apiRoot + "/sandboxRegister", data);
    }

    updateTerms(data: any): Promise<object> {
        return this.$http.post(this.apiRoot + "/updateterms/" + data.uid, data);
    }

    updatePassword(data: any): Promise<object> {
        return this.$http.post(
            this.apiRoot + "/updatepassword/" + data.uid,
            data
        );
    }

    createImage(data: any): Promise<object> {
        return this.$http.post(this.apiRoot + "/image", data);
    }

    removeImage(params: any): Promise<object> {
        return this.$http.delete(this.apiRoot + "/image", { params: params });
    }

    is_active(params: any): Promise<object> {
        return this.$http.get(this.v2Root + "/is_active", { params: params });
    }

    request_access(data: any): Promise<object> {
        return this.$http.get(this.v2Root + "/request_access", data);
    }

    requestSharedLicense(data: any): Promise<object> {
        return this.$http.get(this.v2Root + "/request_shared_license", data);
    }

    resendConfirmation(data: any): Promise<object> {
        return this.$http.post(this.apiRoot + "/resend_confirmation", data);
    }
}

angular.module("vcServices").service("ApiUserService", ApiUserService);
